var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProThemes = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "m6 11-2.08 1.56c-.704.528-1.056.792-1.31 1.126a3 3 0 0 0-.494.99C2 15.08 2 15.52 2 16.4V20l4-1m12-8 2.08 1.56c.704.528 1.056.792 1.31 1.126.225.296.393.632.495.99.115.404.115.844.115 1.724V20l-4-1m-4-8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 22v-3M8.74 4.02l-.687.636c-.756.7-1.134 1.05-1.405 1.466a4 4 0 0 0-.525 1.203C6 7.806 6 8.322 6 9.352V16c0 1.864 0 2.796.305 3.53a4 4 0 0 0 2.164 2.165C9.204 22 10.136 22 12 22v0c1.864 0 2.796 0 3.53-.305a4 4 0 0 0 2.166-2.164C18 18.796 18 17.864 18 16V9.352c0-1.03 0-1.546-.121-2.027a4.002 4.002 0 0 0-.526-1.203c-.27-.416-.649-.766-1.405-1.466l-.687-.636c-1.15-1.065-1.724-1.597-2.378-1.799a3 3 0 0 0-1.766 0c-.653.202-1.228.734-2.378 1.799Z"
})));
export default SvgProThemes;